import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as IconB } from "../Asset/_ÎÓÈ_1.svg";
import useContactUs from "../Routes/utils/sendContactUsMessage";
import "./contact_us.css";

const ContactUs = () => {
  const { mutate: sendMessage, isLoading } = useContactUs();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim())
      newErrors.firstName = "First name is required.";
    if (!formData.lastName.trim())
      newErrors.lastName = "Last name is required.";
    if (
      !formData.phoneNumber.trim() ||
      !/^\d{10,15}$/.test(formData.phoneNumber)
    )
      newErrors.phoneNumber = "Enter a valid phone number.";
    if (
      !formData.email.trim() ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    )
      newErrors.email = "Enter a valid email address.";
    if (!formData.message.trim())
      newErrors.message = "Message cannot be empty.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error(
        "Please ensure all fields are filled out correctly before submitting."
      );
      return;
    }

    sendMessage(formData, {
      onSuccess: () => {
        toast.success("Message sent successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          phoneNumber: "",
          email: "",
          message: "",
        });
      },
      onError: (error) => {
        toast.error(
          `Failed to send message: ${
            error.response?.data?.message || "Unknown error"
          }`
        );
      },
    });
  };

  return (
    <div className="contact-us">
      <div className="card">
        <IconB />
        <div className="page">
          <h3>Contact Us</h3>
          <span>
            <p>Email</p>
            <a href="mailto:Connect@vatug.com">Connect@vatug.com</a>
          </span>
          <p>Send us a message</p>
          <form onSubmit={handleSubmit}>
            <div className="grid">
              <label>
                First Name
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                />
                {errors.firstName && (
                  <span className="error">{errors.firstName}</span>
                )}
              </label>
              <label>
                Last Name
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                />
                {errors.lastName && (
                  <span className="error">{errors.lastName}</span>
                )}
              </label>
              <label>
                Phone Number
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                />
                {errors.phoneNumber && (
                  <span className="error">{errors.phoneNumber}</span>
                )}
              </label>
              <label>
                Email Address
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <span className="error">{errors.email}</span>}
              </label>
            </div>
            <label>
              Your Message
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              {errors.message && (
                <span className="error">{errors.message}</span>
              )}
            </label>
            <button type="submit" disabled={isLoading}>
              {isLoading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ContactUs;
